import {useEffect, useState} from 'react';
import {useNotificationContext} from 'contexts';
import {genericMessageHandler, usePromise} from 'shared/helpers';
import {getGapSizeDefaults} from 'service/RoomService';

// NOTE: Setting page is using this hook.
// Update that to use rtkquery and remove this hook.
export const useMarginDefaultsData = () => {
    const [loader, setLoader] = useState(false);
    const {notify} = useNotificationContext();
    const [gapSizes, setGapSizes] = useState([]);
    const [refreshHack, setRefreshHack] = useState({});

    useEffect(() => {
        setLoader(true);
        const resetCache = refreshHack.hasOwnProperty('noCache')
            ? refreshHack.noCache
            : false;
        const gapSizePromise = getGapSizeDefaults(resetCache);

        return usePromise(
            ([gapSizes]) => {
                setGapSizes(
                    gapSizes.map((gapSize) => ({
                        upperTopGap: gapSize.upperTopGap,
                        upperBottomGap: gapSize.upperBottomGap,
                        ...gapSize,
                    }))
                );
                setLoader(false);
            },
            [gapSizePromise],
            (error) => {
                genericMessageHandler(notify, error);
                setLoader(false);
            }
        );
    }, [refreshHack]);

    return {
        loader,
        setLoader,
        gapSizes,
        refreshGap: setRefreshHack,
    };
};
